import React from "react";
import moment from "moment";
import { PlaiFooterProps } from "./plai-footer.types";
import "./plai-footer.css";

const PlaiFooter = (props: PlaiFooterProps) => {
  const contentWithDynamicYear = props.content
    .replace("{year}", moment().format("YYYY"))
    // plai start here
    .replace(/\\n/g, "<br>");
  // plai end here

  return (
    <div className="bg-black">
      <div
        className="max-w-[1440px] mx-auto plai-footer-wrapper text-white text-[10px]"
        dangerouslySetInnerHTML={{
          __html: contentWithDynamicYear,
        }}
      />
    </div>
  );
};

export default PlaiFooter;
